import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { DialogActions as MuiDialogActions } from "@material-ui/core";

import { DialogActionsStyles } from "./commonStyles";

const DialogActionsCommonComponent = props => (<MuiDialogActions {...props} />);

export default withStyles(DialogActionsStyles)(DialogActionsCommonComponent);
